interface Props {
  label: string
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

export function EmotionSlider({ label, value, onChange, disabled = false }: Props) {
  const getColor = (val: number) => {
    if (val <= 3) return 'var(--color-success)'
    if (val <= 6) return 'var(--color-warning)'
    return 'var(--color-error)'
  }

  return (
    <div className="emotion-slider">
      <div className="emotion-slider-header">
        <span className="emotion-slider-label">{label}</span>
        <span className="emotion-slider-value" style={{ color: getColor(value) }}>
          {value}
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="10"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        disabled={disabled}
        className="slider"
        style={{
          '--slider-color': getColor(value),
        } as React.CSSProperties}
      />
      <div className="emotion-slider-labels">
        <span>Low</span>
        <span>Moderate</span>
        <span>High</span>
      </div>
    </div>
  )
}
